import { Paper, Box } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Header from '../../components/global/Header';
import Logo from '../../assets/Images/dummy-company.png';
import client from '../../API/client';
import Colors from '../../Constant/Colors';
import moment from 'moment/moment';
import { UserContextData } from '../../context/AuthContext';

export const RecruiterApplicants = () => {
  const [applicantdata, setApplicantdata] = useState([]);
  const { Recruiter } = useContext(UserContextData);

  const getApplicantsDetails = async () => {
    const recruiter_id = await Recruiter.recruiter_id;
    const payload = { recruiter_id };
    try {
      await client
        .post(`/recruiter/get-job-applicants-details`, payload, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(async (res) => {
          setApplicantdata(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getApplicantsDetails();
  }, []);

  return (
    <>
      <Container fluid style={{ padding: '20px' }}>
        <Header
          title="Applicant details"
          subtitle="Jobs based on your profile"
        />
        <Paper
          elevation={5}
          style={{
            padding: '20px',
            height: '650px',
            overflow: 'scroll',
            backgroundColor: 'whitesmoke',
            marginTop: '10px',
          }}>
          {applicantdata.map((data) => (
            <div key={data.applicant_id}>
              <Accordion sx={{ mb: '10px', mt: '10px' }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header">
                  <Box>
                    <Box
                      sx={{
                        flexDirection: 'row',
                        padding: '10px',
                        display: 'flex',
                        gap: '20px',
                      }}>
                      <img
                        alt="company logo"
                        src={Logo}
                        style={{
                          width: 80,
                          height: 80,
                          borderRadius: '50%',
                          objectFit: 'cover',
                        }}
                      />
                      <div style={{ flexDirection: 'column', display: 'flex' }}>
                        <span
                          style={{ fontSize: '25px', color: Colors.primary }}>
                          {data.fullname}{' '}
                          <span
                            style={{
                              fontSize: '18px',
                              marginLeft: '10px',
                              color: 'green',
                            }}>
                            {moment(data.createdat).fromNow()}
                          </span>
                        </span>
                        <span style={{ fontSize: '18px', color: 'grey' }}>
                          Applied for :- {data.jobtitle}
                        </span>
                        <div
                          style={{
                            flexDirection: 'row',
                            display: 'flex',
                            justifyContent: 'space-between',
                            paddingTop: '5px',
                          }}>
                          <span>Skills :- {data.skills} </span>
                        </div>
                      </div>
                    </Box>
                  </Box>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: '20px' }}>
                  <Box sx={{ marginLeft: '20px' }}>
                    <div style={{}}>
                      <h4>Designer Details</h4>
                    </div>
                    <div className="post-details">
                      <span style={{ fontWeight: '500' }}>Username :- </span>
                      {data.username}
                    </div>
                    <div className="post-details">
                      <span style={{ fontWeight: '500' }}>Email :- </span>
                      {data.email}
                    </div>
                    <div className="post-details">
                      <span style={{ fontWeight: '500' }}>
                        Portfolio_Url :-{' '}
                      </span>
                      <a href={data.portfolio}>{data.portfolio}</a>
                    </div>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </div>
          ))}
        </Paper>
      </Container>
    </>
  );
};
